import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-ion-common-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {


  @Input() id: string;
  @Input() label = '';
  @Input() loading_verify = false;
  @Input() approved_verify = false;
  @Input() typeButton: 'light' | 'dark' = 'dark';
  @Input() positionButton: 'block' | 'fixed' = 'fixed';
  @Input() disabled = false;
  @Input() ariaLive = false;
  @Input() parentContentScroll = '';
  @Output() clickButton = new EventEmitter<void>();
  @ViewChild('bar') bar: ElementRef;

  emitButton($event: any) {
    $event.preventDefault();
    this.clickButton.emit();
  }

}